import {
  GET_SALESPAYMENT,
  GET_SALESPAYMENT_SUCCESS,
  GET_SALESPAYMENT_FAIL,
  DELETE_SALESPAYMENT,
  DELETE_SALESPAYMENT_SUCCESS,
  DELETE_SALESPAYMENT_FAIL,
  UPDATE_SALESPAYMENT,
  UPDATE_SALESPAYMENT_SUCCESS,
  UPDATE_SALESPAYMENT_FAIL,
  ADD_NEW_SALESPAYMENT,
  ADD_SALESPAYMENT_SUCCESS,
  ADD_SALESPAYMENT_FAIL,
  SALESPAYMENT_LOADING,
  SALESPAYMENT_RESET,
} from "./actionType";

export const resetSalesPaymentState = (actionType) => ({
  type: SALESPAYMENT_RESET,
  payload: { actionType },
});

export const getSalesPaymentSuccess = (actionType, data) => ({
  type: GET_SALESPAYMENT_SUCCESS,
  payload: { actionType, data },
});

export const getSalesPaymentFail = (actionType, error) => ({
  type: GET_SALESPAYMENT_FAIL,
  payload: { actionType, error },
});

export const getSalesPayment = data => ({
  type: GET_SALESPAYMENT,
  payload: data,
});

export const getSalesPaymentLoading = () => ({
  type: SALESPAYMENT_LOADING
});

export const deleteSalesPayment = data => ({
  type: DELETE_SALESPAYMENT,
  payload: data,
});

export const deleteSalesPaymentSuccess = data => ({
  type: DELETE_SALESPAYMENT_SUCCESS,
  payload: data,
});

export const deleteSalesPaymentFail = error => ({
  type: DELETE_SALESPAYMENT_FAIL,
  payload: error,
});

export const updateSalesPayment = data => ({
  type: UPDATE_SALESPAYMENT,
  payload: data,
});

export const updateSalesPaymentFail = error => ({
  type: UPDATE_SALESPAYMENT_FAIL,
  payload: error,
});

export const updateSalesPaymentSuccess = data => ({
  type: UPDATE_SALESPAYMENT_SUCCESS,
  payload: data,
});

export const addNewSalesPayment = data => ({
  type: ADD_NEW_SALESPAYMENT,
  payload: data,
});

export const addSalesPaymentSuccess = data => ({
  type: ADD_SALESPAYMENT_SUCCESS,
  payload: data,
});

export const addSalesPaymentFail = error => ({
  type: ADD_SALESPAYMENT_FAIL,
  payload: error,
});